module.exports = __webpack_public_path__ + "static/media/services.9450f147.svg";